import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { RequestList } from './pages/RequestList';
import { SubmitRequest } from './pages/SubmitRequest';
import { AdminPanel } from './pages/AdminPanel';
import { SupportSubmit } from './pages/SupportSubmit';
import { SupportReply } from './pages/SupportReply';
import { getCurrentUser } from './services/api';
import './App.css';

function App() {
  const [user, setUser] = useState<{ userId: string; userDetails: string; userRoles: string[]; displayName: string }>({ userId: '', userDetails: '', userRoles: [], displayName: '' });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getCurrentUser().then(u => { setUser(u); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ padding: 40, textAlign: 'center' }}>Chargement...</div>;

  const isLoggedIn = !!user.userId;
  const isAdmin = isLoggedIn && (user.userDetails === 'contact@alconseil.info');
  // Members can submit — anyone logged in is at least a member
  const isMember = isLoggedIn;

  return (
    <BrowserRouter>
      <Routes>
        {/* Public reply page (no Entra needed, JWT-gated) */}
        <Route path="/support/reply/:ticketId" element={<SupportReply />} />

        <Route element={<Layout isAdmin={isAdmin} isMember={isMember} userName={user.displayName} isLoggedIn={isLoggedIn} />}>
          <Route path="/" element={<RequestList userId={user.userId} isAdmin={isAdmin} />} />
          {isMember && <Route path="/submit" element={<SubmitRequest userId={user.userId} userUpn={user.userDetails} />} />}
          {isAdmin && <Route path="/admin" element={<AdminPanel />} />}
          {isAdmin && <Route path="/support/submit" element={<SupportSubmit userUpn={user.userDetails} />} />}
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
